var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pageloader has-background-primary is-left-to-right"},[_c('span',{staticClass:"title"},[_vm._v("Cargando")])])}]

export { render, staticRenderFns }